<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Agreement'"
      [canGoBack]="!windowService.isDesktopRes" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      <tidy-card>
        <form [formGroup]="form" novalidate action="#">
          <tidy-row>
            <tidy-input
              [label]="'Agreement Name'"
              formControlName="agreementName"
              [form]="form.controls.agreementName"
              [icon]="'assets/svg/document-text-outline.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter an agreement name'" />
          </tidy-row>
        </form>
      </tidy-card>
      <tidy-button
        [text]="'Save'"
        [action]="saveAction"
        class="primary" />
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
